if (!customElements.get('header-countdown')) {
  customElements.define('header-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      this.duration = Math.max(1, Math.floor(Number(this.dataset.durationSeconds) || 54000));
      this.editorPreview = this.dataset.editorPreview === 'true' || window.Shopify?.designMode === true;
      this.showAfterExpiry = this.dataset.showAfterExpiry !== 'false';
      this.storageKey = `casavelluti:countdown:${this.dataset.campaign || 'free-shipping'}`;
      this.deadline = this.editorPreview ? Date.now() + this.duration * 1000 : this.loadDeadline();
      this.digits = ['hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
      this.lastRemaining = null;
      this.onStorage = (event) => {
        if (event.key !== this.storageKey) return;
        const deadline = Number(event.newValue);
        if (Number.isFinite(deadline) && deadline > 0) {
          this.deadline = deadline;
          this.update();
        }
      };
      if (!this.editorPreview) window.addEventListener('storage', this.onStorage);
      this.update();
      this.removeAttribute('data-initializing');
      this.interval = window.setInterval(() => this.update(), 250);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      window.removeEventListener('storage', this.onStorage);
    }

    loadDeadline() {
      // A page-level fallback also preserves the deadline across editor reloads
      // when both browser storage APIs are blocked.
      const deadlines = window.casavellutiCountdownDeadlines ||= new Map();
      for (const name of ['localStorage', 'sessionStorage']) {
        try {
          const saved = Number(window[name].getItem(this.storageKey));
          if (Number.isFinite(saved) && saved > 0) {
            deadlines.set(this.storageKey, saved);
            return saved;
          }
        } catch { /* Try the next storage option. */ }
      }
      const deadline = deadlines.get(this.storageKey) || Date.now() + this.duration * 1000;
      deadlines.set(this.storageKey, deadline);
      for (const name of ['localStorage', 'sessionStorage']) {
        try { window[name].setItem(this.storageKey, String(deadline)); } catch { /* Use the in-page fallback. */ }
      }
      return deadline;
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (remaining === this.lastRemaining) return;
      this.lastRemaining = remaining;
      if (remaining === 0 && !this.showAfterExpiry) {
        const announcement = this.closest('.shopify-section') || this.closest('.custom-announcement-bar');
        if (announcement) {
          announcement.hidden = true;
          announcement.setAttribute('aria-hidden', 'true');
        }
        clearInterval(this.interval);
        return;
      }
      const values = [Math.floor(remaining / 3600), Math.floor((remaining % 3600) / 60), remaining % 60];
      this.digits.forEach((digit, index) => {
        digit.textContent = String(values[index]).padStart(2, '0');
      });
    }
  });
}
